import { useLazyQuery } from '@apollo/client';

import GetCustomerNameQuery from '@/graphql/contracts/getCustomerName.query.gql';
import { GetCustomerName, GetCustomerNameVariables } from '@/graphql/contracts/_generated_/getCustomerName.query';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

export function useGetCustomerName() {
  const [_getCustomerName, { loading, error, data }] = useLazyQuery<GetCustomerName, GetCustomerNameVariables>(
    GetCustomerNameQuery,
    {
      client: apolloClientContracts,
    }
  );

  const getCustomerName = (customerId: GetCustomerNameVariables['customerId']) => {
    _getCustomerName({
      variables: {
        customerId
      }
    });
  };

  return {
    getCustomerName,
    customerName: data?.customer.customerName,
    customerCode: data?.customer.customerAccountNumber,
    isLoading: loading,
    error,
  } as const;
}
